import { getProduitsOrganisationHandler } from './overrides/getProduitsOrganisationHandler'
import { updateProduitOrganisationHandler } from './overrides/updateProduitOrganisationHandler'

export const handlers = [
  getProduitsOrganisationHandler(),
  updateProduitOrganisationHandler(),
]
